import * as Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import InputSearch from '../../../containers/Learn/Search/InputSearch';
import SearchResults from '../../../containers/Learn/Search/SearchResults';
import { localeData } from '../../../locales/data';
import { FAQ_SEARCH_URL } from '../../../shared/constants';
import { formatHTMLMessageHelper, FormattedMessageHelper, makeLinkRenderer } from '../../../shared/helpers/internationalization';
import { HOCPanel } from '../../Panel/Panel';
import { Filters } from '../Filters/Filters';
import { LearnMainReferences } from '../LearnMainReferences';

const Panel = HOCPanel();

interface LearnSearchMainProps {
  queryTerm: string;
  numOfResults: number;
  handleFilters: (filter: string) => void;
  queryFilters: Immutable.List<string>;
  // The pathname where the current Learn Component it is been displayed
  // Eg : in this route /simulate the value is simulate, for the route /learn the value is learn
  path: string;
  getQueryValues: () => Object;
  handlerToogleFilter: (action: boolean) => void;
  filterOpen: boolean;
}

export const LearnSearchMainIntl = ({
  queryTerm,
  queryFilters,
  numOfResults = 0,
  handleFilters,
  intl,
  path,
  getQueryValues,
  filterOpen,
  handlerToogleFilter,
}: LearnSearchMainProps & InjectedIntlProps) => (
  <div className="learn__content">
    <div className="learn__search-header">
      <InputSearch modifiers={['medium']} defaultValue={queryTerm} path={path} />
    </div>
    <Panel hasHeader={false}>
      <div>
        <div className="learn__search-filters-content">
          <div className="learn__search-results">
            {numOfResults}
            <FormattedMessageHelper
              tagName="span"
              id="learn.search.results.found"
              defaultMessage={localeData.en['learn.search.results.found']}
            />
          </div>
          <Filters
            handleFilters={handleFilters}
            queryFilters={queryFilters}
            handlerToogleFilter={handlerToogleFilter}
            filterOpen={filterOpen}
          />
        </div>
        <div className="learn__search-messages">
          {formatHTMLMessageHelper(intl, 'learn.search.cannot.see.relevant', {
            // @ts-expect-error react-intl values record too strict for renderer prop
            linkInNewTabFAQSearchWithQuery: makeLinkRenderer({ href: `${FAQ_SEARCH_URL}&query=${queryTerm}`, isOpenInNewTab: true }),
          })}
        </div>
        <SearchResults
          modifiers={['video-course']}
          title={intl.formatMessage({ id: 'learn.search.video.course', defaultMessage: localeData.en['learn.search.video.course'] })}
          id="video"
          queryFilters={queryFilters}
          queryTerm={queryTerm}
          path={path}
          getQueryValues={getQueryValues}
        />
        <SearchResults
          modifiers={['tutorial']}
          title={intl.formatMessage({ id: 'learn.search.tutorial', defaultMessage: localeData.en['learn.search.tutorial'] })}
          id="tutorialPage"
          queryFilters={queryFilters}
          queryTerm={queryTerm}
          path={path}
          getQueryValues={getQueryValues}
        />
        <LearnMainReferences path={path} showSearch={false} panelModifiers={['hide-borders']} />
      </div>
    </Panel>
  </div>
);

export const LearnSearchMain = injectIntl(LearnSearchMainIntl);
